/**
 * Store for data observed in the Redirect Relay Medium.
 *
 * This data should be present on a post-redirect page, and should /rarely/ be present on any other page load.
 *
 * With the Cookie medium, the data may only be accessible for the first couple seconds before the cookie expires.
 * This is why we need to eagerly observe the data and preserve it in this store during initialization,
 * especially if we want to support trackingPolicies.PostRedirectPolicies.TRACK_AFTER_SYNC.
 *
 * @module
 */

var actionTypes = require('../constants/action_types');
var freeze = require('../utils/freeze');

module.exports = {
  initialize: function () {
    this.__state = {
      data: null,
      hasTracked: null,
    };

    this.on(actionTypes.LOAD_REDIRECT_DATA, this.__setRedirectInfo);
    this.on(actionTypes.REGISTER_TRACKED_REDIRECT_DATA, this.__registerTracked);
  },

  /**
   * @returns {PersistableDecisionWithContext|null}
   */
  get: function(): PersistableDecisionWithContext|null {
    return freeze.safeReference(this.__state.data);
  },

  /**
   * @returns {boolean|null}
   */
  hasTracked: function(): boolean|null {
    return this.__state.hasTracked;
  },

  /**
   * @param {PersistableDecisionWithContext} payload
   * @private
   */
  __setRedirectInfo: function(payload:PersistableDecisionWithContext) {
    if (__INVARIANT__) {
      require('core/utils/invariant').isType('PersistableDecisionWithContext', payload);
    }
    freeze.deepFreeze(payload);
    this.__state.data = payload;
    this.__state.hasTracked = false;
    this.emitChange();
  },

  /**
   * @private
   */
  __registerTracked: function() {
    this.__state.hasTracked = true;
  },
};
